import { Mail, HardDrive, Calendar, UserCheck, Video, ShieldCheck, LifeBuoy } from "lucide-react";

export const TOPIC_META = {
  mail: { Icon: Mail, color: "#D93025", bg: "#FCE8E6" },
  drive: { Icon: HardDrive, color: "#188038", bg: "#E6F4EA" },
  calendar: { Icon: Calendar, color: "#1A73E8", bg: "#E8F0FE" },
  account: { Icon: UserCheck, color: "#B06000", bg: "#FEF7E0" },
  meet: { Icon: Video, color: "#0E8BA0", bg: "#E4F7FB" },
  security: { Icon: ShieldCheck, color: "#9334E6", bg: "#F3E8FD" },
};

export function topicMeta(key) {
  return TOPIC_META[key] || { Icon: LifeBuoy, color: "#5F6368", bg: "#F1F3F4" };
}

export const ICON_OPTIONS = [
  { key: "mail", label: "Mail" },
  { key: "drive", label: "Drive" },
  { key: "calendar", label: "Calendar" },
  { key: "account", label: "Account" },
  { key: "meet", label: "Meet / Video" },
  { key: "security", label: "Security" },
];
